import {axios as http} from "@/plugins/http"

export default class Api {
    static shops(postId) {
        return http.post("/api/v1/post/mark-ad-auto/shops", {
            "post_id": postId,
        }).then((resp) => {
            return resp.data
        })
    }

    static category(postId) {
        return http.post("/api/v1/post/mark-ad-auto/category", {
            "post_id": postId,
        }).then((resp) => {
            return resp.data
        })
    }
}
